import React from 'react'
import { Schedule, useCompany, useSchedules } from 'zens-store'
import { ViewProps } from 'react-native'

import { Grid, GridItemInfo } from '../grid'

import ScheduleCard from './card'
import ScheduleEmpty from './empty'

interface Props extends ViewProps {
  companyId: number
  search?: string
}

const ScheduleGrid = (props: Props) => {
  const { companyId, search, ...otherProps } = props
  const schedules = useSchedules({ companyId, search })
  const company = useCompany({ companyId })
  const colorScheme = company.data!.colorScheme
  const items = schedules.data?.map((schedule) => ({
    data: schedule,
    href: `/companies/${companyId}/workspaces/schedules/${schedule.id}`,
  }))

  const renderSchedule = (info: GridItemInfo<Schedule>) => {
    const { item } = info
    const { data } = item
    return <ScheduleCard schedule={data} colorScheme={colorScheme} />
  }

  if (!items?.length) return <ScheduleEmpty companyId={companyId} search={search} />

  return (
    <Grid
      items={items}
      renderItem={renderSchedule}
      typeHref={(type) => ({
        pathname:
          type === 'table'
            ? `/companies/${companyId}/workspaces/schedules`
            : `/companies/${companyId}/workspaces/schedules/grid`,
        params: { search },
      })}
      {...otherProps}
    />
  )
}

export default ScheduleGrid
